var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWaitUntilNodeIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 24,
    height: 24,
    rx: 4,
    fill: "#137FFD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 12.5007L9.15137 10.1268C8.72813 9.77413 8.51652 9.59778 8.36438 9.38161C8.22959 9.19007 8.12949 8.97634 8.06864 8.75017C7.99996 8.49491 7.99996 8.21944 7.99996 7.66852V5.83398M12 12.5007L14.8485 10.1268C15.2718 9.77413 15.4834 9.59778 15.6355 9.38161C15.7703 9.19007 15.8704 8.97634 15.9313 8.75017C16 8.49491 16 8.21944 16 7.66852V5.83398M12 12.5007L9.15137 14.8745C8.72814 15.2272 8.51652 15.4035 8.36438 15.6197C8.22959 15.8112 8.12949 16.025 8.06864 16.2511C7.99996 16.5064 7.99996 16.7819 7.99996 17.3328V19.1673M12 12.5007L14.8486 14.8745C15.2718 15.2272 15.4834 15.4035 15.6355 15.6197C15.7703 15.8112 15.8704 16.025 15.9313 16.2511C16 16.5064 16 16.7819 16 17.3328V19.1673M6.66663 5.83398H17.3333M6.66663 19.1673H17.3333",
    stroke: "#EEF9FF",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaitUntilNodeIcon);
export default __webpack_public_path__ + "static/media/waitUntilNodeIcon.189843d6e257022eccd15879719181de.svg";
export { ForwardRef as ReactComponent };